import { SimpleFieldConfig } from "@/components/shared/UniversalCRMTable/types";

/**
 * Determine the category for a field based on its type and name
 */
export function getCategoryForField(field: SimpleFieldConfig, fieldName: string): string {
  // Check field name patterns first
  if (
    fieldName.includes("status") ||
    fieldName.includes("priority") ||
    fieldName.includes("state")
  ) {
    return "status";
  }

  if (fieldName.includes("assigned") || fieldName.includes("user") || fieldName.includes("owner")) {
    return "assignment";
  }

  if (
    fieldName.includes("date") ||
    fieldName.includes("time") ||
    fieldName.includes("created") ||
    fieldName.includes("updated")
  ) {
    return "dates";
  }

  if (fieldName.includes("contact") || fieldName.includes("email") || fieldName.includes("phone")) {
    return "contact";
  }

  if (
    fieldName.includes("amount") ||
    fieldName.includes("price") ||
    fieldName.includes("cost") ||
    fieldName.includes("rate")
  ) {
    return "financial";
  }

  if (
    fieldName.includes("tags") ||
    fieldName.includes("notes") ||
    fieldName.includes("description")
  ) {
    return "metadata";
  }

  // Check field type
  switch (field.type) {
    case "date":
    case "datetime":
      return "dates";
    case "number":
      return fieldName.includes("amount") ||
        fieldName.includes("price") ||
        fieldName.includes("cost")
        ? "financial"
        : "basic";
    case "boolean":
      return "status";
    case "multi-user":
      return "assignment";
    default:
      return "basic";
  }
}

/**
 * Get default width based on field type
 */
export function getDefaultWidth(type: SimpleFieldConfig["type"]): number {
  switch (type) {
    case "date":
    case "datetime":
      return 120;
    case "number":
      return 100;
    case "boolean":
      return 80;
    case "textarea":
      return 200;
    case "multi-user":
      return 150;
    case "tags":
      return 180;
    case "select":
      return 130;
    default:
      return 150;
  }
}

/**
 * Determine mobile priority for responsive layouts
 */
export function getMobilePriority(fieldName: string, index: number): number {
  // Essential fields get higher priority (lower numbers)
  const essentialFields = ["title", "name", "status", "priority", "assigned_to", "created_at"];

  if (essentialFields.includes(fieldName)) {
    return index + 1; // Keep original priority for essential fields
  }

  // Non-essential fields get lower priority
  return index + 100;
}

/**
 * Determine mobile layout type for responsive design
 */
export function getMobileType(
  field: SimpleFieldConfig,
  fieldName: string
): "primary" | "secondary" | "badge" | "hidden" {
  // Primary fields - most important info
  if (["title", "name"].includes(fieldName)) {
    return "primary";
  }

  // Badge fields - status indicators
  if (["status", "priority"].includes(fieldName) || field.type === "boolean") {
    return "badge";
  }

  // Secondary fields - supporting info
  if (["assigned_to", "created_at", "due_date"].includes(fieldName)) {
    return "secondary";
  }

  // Hide actions and large text fields on mobile
  if (fieldName === "actions" || field.type === "textarea") {
    return "hidden";
  }

  // Default to secondary for other fields
  return "secondary";
}
